export const OPEN_POLICY_SEARCH_MODAL= 'OPEN_POLICY_SEARCH_MODAL';
export const SAVE_POLICY_RESULT= 'SAVE_POLICY_RESULT';

export const openPolicySearchModal =  toggleType => ({
    type: OPEN_POLICY_SEARCH_MODAL,
    payload: toggleType,
});

export const searchPolicyResult =  policies => ({
    type: SAVE_POLICY_RESULT,
    payload: policies,
});



// WEBPACK FOOTER //
// ./src/actions/policies.js